import React, { useState, useEffect } from 'react';
import { Container, Button, Box, Snackbar, Alert, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';
import { useLocation } from 'react-router-dom';

const UserTokenSubmission = () => {
  // Force Vercel redeploy - updated login design
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const location = useLocation();

  useEffect(() => {
    if (location.state) {
      if (location.state.success) {
        setSnackbar({ open: true, message: location.state.success, severity: 'success' });
      } else if (location.state.error) {
        setSnackbar({ open: true, message: location.state.error, severity: 'error' });
      }
      window.history.replaceState({}, document.title);
    }
  }, [location]);

  const handleDiscordAuth = async () => {
    try {
      sessionStorage.setItem('userSubmission', 'true');
      const response = await fetch('http://localhost:3031/login');
      const data = await response.json();
      window.location.href = data.authUrl;
    } catch (error) {
      console.error('Failed to get auth link:', error);
      setSnackbar({ open: true, message: 'Failed to connect to authorization service. Please try again.', severity: 'error' });
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#121212',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 2,
      }}
    >
      <Container component="main" maxWidth="sm">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            backgroundColor: '#1e1e1e',
            borderRadius: 2,
            padding: 4,
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
          }}
        >
          <Snackbar
            open={snackbar.open}
            autoHideDuration={6000}
            onClose={() => setSnackbar({ ...snackbar, open: false })}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          >
            <Alert
              onClose={() => setSnackbar({ ...snackbar, open: false })}
              severity={snackbar.severity}
              sx={{ width: '100%' }}
            >
              {snackbar.message}
            </Alert>
          </Snackbar>

          <Typography
            variant="h5"
            component="h1"
            sx={{
              color: 'white',
              fontWeight: 'bold',
              mb: 3,
              textAlign: 'center',
            }}
          >
            VaultCord Login
          </Typography>

          <Button
            variant="contained"
            size="large"
            startIcon={<Add />}
            onClick={handleDiscordAuth}
            sx={{
              py: 1.5,
              px: 3,
              fontSize: '1rem',
              fontWeight: 'bold',
              backgroundColor: '#5865f2',
              color: 'white',
              '&:hover': {
                backgroundColor: '#4752c4',
              },
              textTransform: 'none',
              minWidth: 200,
            }}
          >
            Login with Discord
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default UserTokenSubmission;